import { VFC } from "react";
import { useHistory } from "react-router-dom";
import { AcadCard } from "@components";
import ScholarshipBenefit from "@models/scholarship_benefit";

const BenefitCard: VFC<{ benefit: ScholarshipBenefit }> = ({ benefit }) => {
  const history = useHistory();
  return (
    <AcadCard
      onClick={() => history.push(`/scholarship/benefits/${benefit.id}`)}
    >
      <div className="flex flex-col pl-4">
        <div className="text-md leading-none text-left">{benefit.name}</div>
        <div className="text-xs leading-none text-left opacity-40">
          {benefit.id}
        </div>
      </div>
    </AcadCard>
  );
};

export default BenefitCard;
